import { FeatureFlag } from "../types/FeatureFlag";
import { DEFAULT_FEATURE_FLAGS } from "./DEFAULT_FEATURE_FLAGS";

export const FEATURE_FLAGS = Object.keys(
  DEFAULT_FEATURE_FLAGS
) as FeatureFlag[];
